'SalesInvoiceCsv'.output()
'INVOICE'.title()
'orders'.datatype()

'Header'.section({pageHeading: true})
'order_id'.field({caption: "Invoice Number"})
"order_date".field()
'dueDate'.field()
'billingNameAndCompany'.field({caption: "Bill To"})
'billingAddress'.field({caption: ""})
'billingEmailAndPhone'.field({caption: ""})
'ourBusinessName'.field({caption: "From"})
'ourFromAddress'.field({caption: ""})
'ourContactDetails'.field({caption: ""})
'ourTaxId'.field({caption: "Tax ID"})
'_order_shipping'.field({caption: "Shipping"})
'fees_total'.field({caption: "Fees"})
'totalTax'.field({caption: "Tax"})
'_order_total'.field({caption: "Invoice Total"})
'_order_currency'.field()
'paidAmount'.field({caption: "Paid Amount"})
'unpaidExcludingThis'.field({caption: "Other Invoices Owing"})
'totalDueWithCurrency'.field({caption: "Total to Pay"})
'terms'.field()
'paymentInstructions'.field()

'Lines'.manifest()
'order_items'.datatype()
'productUniqueName'.field({caption: "Product"})
'productSku'.field({caption: "SKU"})
'_qty'.field({caption: "Qty"})
'unitPriceExTax'.field({caption: "Price"})
'_line_total'.field({caption: "Amount"})
